import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.AuthorProfiles';

export default defineMessages({
  pageHeadingText: {
    id: `${scope}.pageHeadingText`,
    defaultMessage: 'Author Profiles',
  },
});